import { Injectable } from '@angular/core';

import { BetslipV2Pick } from '../../../../../core/picks/betslip-v2-pick';
import { isRacePick } from '../../../../picks/services/betslip-pick-helpers';
import { CriteriaType, IRewardToken } from '../../../reward-tokens.model';
import { TokenValidationInput, TokensCriteriaValidatorBase } from '../criteria-validator-base.service';

@Injectable()
export class MeetingsValidator extends TokensCriteriaValidatorBase<IRewardToken, CriteriaType> {
    override type = CriteriaType.Meetings;

    isValid({ filter }: IRewardToken, state: TokenValidationInput): boolean {
        if (filter?.meetings?.length > 0) {
            const eligibleMeetings = new Set(filter.meetings.map((m) => m.id));

            return state.selectedPicks.every(
                (pick) => BetslipV2Pick.isPick(pick) && isRacePick(pick) && eligibleMeetings.has(pick.fixture.league!.id),
            );
        }

        return true;
    }
}
